import React, { FC } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { AUTH0_SCOPE, ExtendedAuthProvider } from '../../util/auth0';
import { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_ORGANIZATION_ID } from '../../config';

export const AppAuthProvider: FC<{ children: React.ReactNode }> = ({ children }) => {

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: AUTH0_AUDIENCE,
        organization: AUTH0_ORGANIZATION_ID,
        redirect_uri: window.location.origin,
        scope: AUTH0_SCOPE
      }}
    >
      <ExtendedAuthProvider>
        {children}
      </ExtendedAuthProvider>
    </Auth0Provider>
  );
};
